import core from '../core';
import ModelImageUpdater from '../models/product-image-updater';
import { getClosestParentElement } from '../../helpers/dom-interact';

const ViewImageUpdater = core.extend({
	constructor(opts) {
		if (!opts) {
			throw new Error('params are missing');
		}

		this.mainImg = opts.mainImg;
		this.crossSellingImg = opts.crossSellingImg;
		this.sliderImg = opts.sliderImg;
		this.galleryImg = opts.galleryImg;

		this.modelImgUpdater = new ModelImageUpdater(opts);
	},

	setActiveProduct(product, preselection) {
		const format = product.format.slice(1);

		this.modelImgUpdater.setActiveProduct(product, preselection);

		this.setMainImageSrc();
		this.setGalleryImageSrcBasedOnFormat(format);
	},

	setNewSrc(obj) {
		if (!obj) {
			return;
		}

		this.modelImgUpdater.refreshData(obj);

		this.setMainImageSrc();
		this.setGalleryImageSrc();
		this.setSliderImageSrc(obj);
	},

	setMainImageSrc() {
		if (!this.mainImg) {
			return;
		}

		this.mainImg.each((i, img) => {
			this.updateImage(jQuery(img), '-');
		});
	},

	getImageLinkTarget(sliderWrapper) {
		const linkHref = jQuery(sliderWrapper.children(), 'href');
		const linkDataHref = jQuery(sliderWrapper.children(), 'data-href');

		return linkHref || linkDataHref;
	},

	setSliderImageSrc(obj) {
		if (!this.sliderImg || typeof obj.color === 'undefined') {
			return;
		}

		this.sliderImg.each((i, img) => {
			const $img = jQuery(img);
			const sliderWrapper = $img.parents('.js-slide');
			const availableColors = sliderWrapper.data('colors');

			if (availableColors && availableColors.split(',').indexOf(obj.color) === -1) {
				return;
			}
			const imageLink = this.getImageLinkTarget(sliderWrapper);

			this.updateSliderImage($img, obj);

			this.updateAnchor(imageLink, 'color');
		});
	},

	setGalleryImageSrc() {
		if (!this.galleryImg) {
			return;
		}

		this.galleryImg.each((i, img) => {
			if (!img.parentNode.classList.contains('is-hidden')) {
				this.updateImage(jQuery(img), '-');
			}
		});
	},

	setGalleryImageSrcBasedOnFormat(format) {
		if (!this.galleryImg) {
			return;
		}

		this.galleryImg.each((i, img) => {
			const slideItem = getClosestParentElement(img, '.js-slider-tile-item');
			const { formats = '' } = slideItem.dataset;

			if (formats.includes(format)) {
				this.updateImage(jQuery(img), '-');
			}
		});
	},

	updateImage(el, separator) {
		const attributes = ['srcset', 'src'];
		const sources = this.getSources(el, attributes);

		_.each(sources, (currentSrc, currentAttr) => {
			if (!currentSrc) {
				return;
			}

			let src = this.modelImgUpdater.getNewSrc(currentSrc, separator);
			const attr = currentAttr;
			const parent = el.parents('.zoom-image');

			if (parent.length) {
				const concatSign = src.includes('?') ? '&' : '?';

				parent.css({ opacity: 0.4 });
				src = `${src}${concatSign}t=${new Date().getTime()}`;
			}

			el.on('load', () => {
				if (parent.length) {
					parent.css({ opacity: '' });
				}
			})
				.on('error', () => {
					/* eslint no-console: ["warn", { allow: ["log"] }] */
					console.log('error loading image');
				})
				.attr(attr, src);
		});
	},

	updateSliderImage(img, obj) {
		const $img = jQuery(img);
		const src = $img.data('src');
		const data = _.extend(this.modelImgUpdater.originalData, obj);
		const updatedSrc = this.modelImgUpdater.generateCompressedSrc(src, '-', data);

		$img.data('src', updatedSrc).attr('src', updatedSrc);
	},

	updateAnchor($anchor, property) {
		const newValue = this.modelImgUpdater.data[property];

		if (typeof newValue === 'undefined') {
			return;
		}

		const regex = new RegExp(`${property}=[^&]*`);

		/* On PDP slider shouldn't contain any links (for SEO reasons) that's why anchor is replaced with mimic-link which has 'data-href' instead of href */
		const currentHrefAttribute = $anchor.attr('href') ? 'href' : 'data-href';

		let href = $anchor.attr(currentHrefAttribute);

		let separator;

		if (href.match(regex)) {
			href = href.replace(regex, `${property}=${newValue}`);
		} else {
			separator = ~href.indexOf('?') ? '&' : '?';
			href += `${separator}${property}=${newValue}`;
		}

		$anchor.attr(currentHrefAttribute, href);
	},

	getSources(el, attributes) {
		const sources = {};

		_.each(attributes, (element) => {
			sources[element] = el.attr(element);
		});

		return sources;
	},
});

export default ViewImageUpdater;
